import { atom } from 'recoil';

type StatusType = 'idle' | 'loading' | 'success' | 'error';

export type CustomerAtomType = {
    restore: StatusType,
    delete: StatusType,
    reject: StatusType,
}

export const customerAtom = atom<CustomerAtomType>({
  key: 'customerAtom',
  default: {
    restore: 'idle',
    delete: 'idle',
    reject: 'idle',
  },
});


